<ng-container *ngIf="card as c">
  <app-juana-product-card
    *ngIf="c.kind === 'products'"
    [products]="$any(c).products || []"
  ></app-juana-product-card>

  <div class="compat" *ngIf="c.kind === 'fleet-compat'">
    <div class="compat-head">{{ 'repuestos.agent.compatTitle' | transloco }}</div>
    <div class="compat-line ok">{{ 'repuestos.agent.compatOk' | transloco: { n: $any(c).compatible?.length || 0 } }}</div>
    <div class="compat-line no">{{ 'repuestos.agent.compatNo' | transloco: { n: $any(c).incompatible?.length || 0 } }}</div>
  </div>

  <!-- Vehículos de la flota: botones para elegir para cuál es el repuesto -->
  <div class="fleet-veh" *ngIf="c.kind === 'fleet-vehicles'">
    <div class="fleet-veh-head">{{ 'repuestos.agent.chooseVehicle' | transloco }}</div>
    <div class="fleet-veh-empty" *ngIf="!$any(c).vehicles?.length">
      {{ 'repuestos.agent.noFleetVehicles' | transloco }}
    </div>
    <button class="veh-btn" *ngFor="let v of $any(c).vehicles" [disabled]="busy" (click)="chooseVehicle.emit(v)">
      <span class="veh-ico">🚗</span>
      <span class="veh-txt">
        {{ v.brand }} {{ v.model }} {{ v.year }}<span class="veh-plate" *ngIf="v.plate"> · {{ v.plate }}</span>
      </span>
    </button>
    <button class="veh-btn other" [disabled]="busy" (click)="otherVehicle.emit()">
      <span class="veh-ico">➕</span> <span class="veh-txt">{{ 'repuestos.agent.otherVehicle' | transloco }}</span>
    </button>
  </div>

  <!-- Selección de un campo puntual (p. ej. tipo de vehículo, estado): un botón por opción -->
  <div class="fleet-veh" *ngIf="fieldOptions as fo">
    <div class="fleet-veh-head">{{ fo.label }}</div>
    <button
      class="veh-btn"
      *ngFor="let opt of fo.options"
      [disabled]="busy"
      (click)="fieldOptionSelected.emit({ field: fo.field, value: opt.value, label: opt.label })"
    >
      <span class="veh-txt">{{ opt.label }}</span>
    </button>
  </div>

  <!-- Aliados / proveedores -->
  <div class="prov" *ngIf="c.kind === 'providers'">
    <div class="prov-head">{{ 'repuestos.agent.partners' | transloco }} {{ $any(c).hasLocation ? ('repuestos.agent.partnersNearest' | transloco) : '' }}</div>
    <div class="prov-empty" *ngIf="!$any(c).providers?.length">
      {{ 'repuestos.agent.noPartners' | transloco }}
    </div>
    <div class="prov-item" *ngFor="let p of $any(c).providers">
      <img class="prov-img" *ngIf="p.image" [src]="p.image" [alt]="p.name" />
      <div class="prov-info">
        <div class="prov-name">{{ p.name }}</div>
        <div class="prov-dist" *ngIf="p.distanceKm != null">{{ p.distanceKm }} km</div>
      </div>
    </div>
  </div>

  <!-- Solicitud de disponibilidad enviada a talleres -->
  <div class="avail" *ngIf="c.kind === 'availability-requested'">
    <div class="avail-head">{{ 'repuestos.agent.searchingShops' | transloco: { n: $any(c).providers?.length || 0 } }}</div>
    <div class="avail-sub">{{ 'repuestos.agent.checkingAvailability' | transloco: { query: $any(c).query } }}</div>
    <button class="card-link" *ngIf="$any(c).requestId" (click)="viewRequest.emit($any(c).requestId)">
      {{ 'repuestos.agent.viewRequestOffers' | transloco }}
    </button>
  </div>

  <!-- Oferta de un taller (relay proactivo cuando responde la disponibilidad) -->
  <div class="offer" *ngIf="c.kind === 'availability-offer'">
    <div class="offer-head">{{ 'repuestos.agent.offerResponded' | transloco: { provider: $any(c).providerName } }}</div>
    <div class="offer-sub">{{ 'repuestos.agent.offerFor' | transloco: { query: $any(c).query } }}</div>
    <div class="offer-meta">
      <span class="offer-price" *ngIf="$any(c).price != null">{{ $any(c).price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
      <span class="offer-eta" *ngIf="$any(c).etaHours != null">~{{ $any(c).etaHours }} h</span>
      <span class="offer-tag" *ngIf="$any(c).available === 'can_source'">{{ 'repuestos.agent.canSource' | transloco }}</span>
      <span class="offer-stock" *ngIf="$any(c).stock != null">{{ 'repuestos.agent.stock' | transloco: { n: $any(c).stock } }}</span>
    </div>
    <div class="offer-note" *ngIf="$any(c).note">{{ $any(c).note }}</div>
    <ng-container *ngIf="!isBuyOpen($any(c).responseId); else buyFormSlot">
      <button
        class="offer-cta"
        [disabled]="$any(c).price == null"
        (click)="buy.emit({ responseId: $any(c).responseId, providerName: $any(c).providerName, requestId: $any(c).requestId, price: $any(c).price, deliveryOptions: $any(c).deliveryOptions, deliveryFee: $any(c).deliveryFee })"
      >
        {{ 'repuestos.agent.buyWithPartner' | transloco }}
      </button>
      <button class="card-link" *ngIf="$any(c).requestId" (click)="viewRequest.emit($any(c).requestId)">
        {{ 'repuestos.agent.viewAllOffers' | transloco }}
      </button>
    </ng-container>
  </div>

  <!-- Lista de ofertas (list_availability_offers) -->
  <div class="offers" *ngIf="c.kind === 'availability-offers'">
    <div class="offers-head">{{ 'repuestos.agent.offersFor' | transloco: { query: $any(c).query } }}</div>
    <div class="offers-empty" *ngIf="!$any(c).offers?.length">
      {{ 'repuestos.agent.noOffersYet' | transloco }}
    </div>
    <div class="offer-item" *ngFor="let o of $any(c).offers">
      <div class="offer-item-info">
        <div class="offer-item-name">{{ o.providerName }}</div>
        <div class="offer-item-meta">
          <span class="offer-price" *ngIf="o.price != null">{{ o.price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          <span class="offer-eta" *ngIf="o.etaHours != null">~{{ o.etaHours }} h</span>
          <span class="offer-tag" *ngIf="o.available === 'can_source'">{{ 'repuestos.agent.canSource' | transloco }}</span>
        </div>
      </div>
      <ng-container *ngIf="!isBuyOpen(o.responseId); else buyFormSlot">
        <button
          class="offer-cta sm"
          [disabled]="o.price == null"
          (click)="buy.emit({ responseId: o.responseId, providerName: o.providerName, requestId: $any(c).requestId, price: o.price, deliveryOptions: o.deliveryOptions, deliveryFee: o.deliveryFee })"
        >
          {{ 'repuestos.agent.buy' | transloco }}
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Link de pago (create_order) -->
  <div class="offer paylink" *ngIf="c.kind === 'order-payment-link'">
    <div class="offer-head">{{ 'repuestos.agent.orderCreated' | transloco }}</div>
    <div class="offer-meta">
      <span class="offer-price">{{ $any(c).total | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
      <span class="offer-tag">{{ ($any(c).deliveryMode === 'pickup' ? 'repuestos.agent.pickupShort' : 'repuestos.agent.deliveryShort') | transloco }}</span>
    </div>
    <a class="offer-cta" [href]="$any(c).paymentUrl" target="_blank" rel="noopener">
      {{ 'repuestos.agent.payNow' | transloco }}
    </a>
  </div>

  <!-- Pago confirmado (redirect de Stripe con ?paid=1) -->
  <div class="offer paylink paid-card" *ngIf="c.kind === 'order-paid'">
    <div class="offer-head">{{ 'repuestos.agent.paymentConfirmed' | transloco }}</div>
    <div class="offer-meta">
      <span class="offer-price">{{ $any(c).total | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
      <span class="offer-tag">{{ ($any(c).deliveryMode === 'pickup' ? 'repuestos.agent.pickupShort' : 'repuestos.agent.deliveryShort') | transloco }}</span>
    </div>
    <a class="offer-cta" [routerLink]="['/dashboard/repuestos/seguimiento', $any(c).orderId]">
      {{ 'repuestos.agent.viewMyOrder' | transloco }}
    </a>
  </div>

  <!-- Servicios encontrados (search_services): "Agendar" abre el mini-form del
       wrapper, que llama el endpoint de agendar directo — nunca pasa por el LLM. -->
  <div class="offers" *ngIf="c.kind === 'booking-services'">
    <div class="offers-head">{{ 'repuestos.agent.servicesFoundTitle' | transloco }}</div>
    <div class="offers-empty" *ngIf="!$any(c).services?.length">
      {{ 'repuestos.agent.noServicesMatch' | transloco }}
    </div>
    <div class="offer-item" *ngFor="let s of $any(c).services">
      <div class="offer-item-info">
        <div class="offer-item-name">{{ s.providerName }}</div>
        <div class="offer-item-sub">{{ s.serviceName }} · {{ s.subServiceName }}</div>
        <div class="offer-item-meta">
          <span class="offer-price" *ngIf="s.price != null">{{ s.price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
        </div>
      </div>
      <ng-container *ngIf="!isScheduleOpen(rowKey(s)); else scheduleFormSlot">
        <button
          class="offer-cta sm"
          [disabled]="busy"
          (click)="schedule.emit({ providerId: s.providerId, providerName: s.providerName, serviceId: s.serviceId, serviceName: s.serviceName, subServiceId: s.subServiceId, subServiceName: s.subServiceName, price: s.price })"
        >
          {{ 'repuestos.agent.scheduleWithPartner' | transloco }}
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Confirmación de cita agendada: la crea el mini-form (fuera del LLM), esta
       tarjeta solo la refleja después de que el backend confirmó el cobro. -->
  <div class="jc-created" *ngIf="bookingConfirmed as b">
    <div class="jc-created-head">
      <i class="pi pi-check-circle"></i>
      {{ 'repuestos.agent.bookingCreated' | transloco }}
    </div>
    <div class="jc-created-plate">{{ b.serviceName }} · {{ b.subServiceName }}</div>
    <div class="jc-created-sub">{{ b.providerName }}<span *ngIf="b.plate"> · {{ b.plate }}</span></div>
    <div class="jc-created-sub">
      {{ b.date }} {{ b.hour }}<span *ngIf="b.totalAmount != null"> · {{ b.totalAmount | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
    </div>
  </div>

  <!-- Inventario de un aliado -->
  <div class="inv" *ngIf="c.kind === 'provider-inventory'">
    <div class="inv-head">{{ 'repuestos.agent.partnerInventory' | transloco: { query: $any(c).query } }}</div>
    <div class="inv-empty" *ngIf="!$any(c).items?.length">
      {{ 'repuestos.agent.noInventoryMatch' | transloco: { query: $any(c).query } }}
    </div>
    <div class="inv-item" *ngFor="let it of $any(c).items">
      <div class="inv-name">{{ it.brand }} — {{ it.techDescription }}</div>
      <div class="inv-meta">
        <span class="inv-price" *ngIf="it.price != null">{{ it.price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
        <span class="inv-stock" [class.out]="it.stock <= 0">{{ 'repuestos.agent.stock' | transloco: { n: it.stock } }}</span>
      </div>
    </div>
  </div>

  <!-- Salud de flota (get_fleet_health). Sin columna "Prioridad": no existe en
       el contrato de GET /corporate/fleet/health (decisión #6 del plan). -->
  <div class="jc-table-card" *ngIf="fleetHealth as fh">
    <div class="jc-table-head">{{ 'salud.title' | transloco }}</div>
    <div class="jc-table-summary" *ngIf="fh.summary">{{ fh.summary }}</div>
    <div class="jc-table-empty" *ngIf="!fleetVehicles.length">{{ 'salud.noVehicles' | transloco }}</div>
    <div class="jc-table-wrap" *ngIf="fleetVehicles.length">
      <table class="jc-table">
        <thead>
          <tr>
            <th>{{ 'vehicles.plate' | transloco }}</th>
            <th>{{ 'salud.nextMaintenanceColumn' | transloco }}</th>
            <th>{{ 'salud.statusColumn' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of fleetVehicles">
            <td class="jc-strong">{{ v.plate }}</td>
            <td>
              <ng-container *ngIf="v.nextMaintenance; else noNext">{{ v.nextMaintenance.label }}</ng-container>
              <ng-template #noNext>{{ 'salud.noPendingMaintenance' | transloco }}</ng-template>
            </td>
            <td>
              <span class="jc-status" [ngClass]="v.status">{{ 'salud.status.' + v.status | transloco }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Historial de mantenimientos (get_maintenance_history). `cost` y `provider`
       llegan null en registros manuales: se dice que no hay dato, no se inventa. -->
  <!-- Confirmación de vehículo agregado: se muestra SOLO cuando el backend
       confirmó la creación, nunca de forma optimista. -->
  <div class="jc-created" *ngIf="createdVehicle as v">
    <div class="jc-created-head">
      <i class="pi pi-check-circle"></i>
      {{ 'repuestos.agent.vehicleCreated' | transloco }}
    </div>
    <div class="jc-created-plate">{{ v.plate }}</div>
    <div class="jc-created-sub">{{ v.brand }} {{ v.model }} {{ v.year }}<span *ngIf="v.color"> · {{ v.color }}</span></div>
  </div>

  <!-- Confirmación de conductor agregado: se muestra SOLO cuando el backend
       confirmó la creación (tool create_driver), nunca de forma optimista. -->
  <div class="jc-created" *ngIf="createdDriver as d">
    <div class="jc-created-head">
      <i class="pi pi-check-circle"></i>
      {{ 'repuestos.agent.driverCreated' | transloco }}
    </div>
    <div class="jc-created-plate">{{ d.name }} {{ d.lastname }}</div>
    <div class="jc-created-sub">{{ d.email }}</div>
    <div class="jc-created-sub" *ngIf="d.driverStatus === 'pending_registration'">
      <span class="offer-tag">{{ 'repuestos.agent.driverPendingRegistration' | transloco }}</span>
    </div>
  </div>

  <div class="jc-table-card" *ngIf="maintenanceHistory">
    <div class="jc-table-head">{{ 'salud.maintenanceHistory' | transloco }}</div>
    <div class="jc-table-empty" *ngIf="!maintenanceItems.length">{{ 'salud.noHistory' | transloco }}</div>
    <div class="jc-table-wrap" *ngIf="maintenanceItems.length">
      <table class="jc-table">
        <thead>
          <tr>
            <th>{{ 'salud.categoryLabel' | transloco }}</th>
            <th>{{ 'salud.performedAtLabel' | transloco }}</th>
            <th>{{ 'salud.kilometersAtServiceLabel' | transloco }}</th>
            <th>{{ 'salud.costLabel' | transloco }}</th>
            <th>{{ 'salud.providerLabel' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of maintenanceItems">
            <td class="jc-strong">{{ it.label }}</td>
            <td>{{ it.performedAt | date: 'dd/MM/yyyy' }}</td>
            <td>
              <ng-container *ngIf="it.kilometersAtService != null; else noKm">{{ it.kilometersAtService | number }} km</ng-container>
              <ng-template #noKm><span class="jc-muted">—</span></ng-template>
            </td>
            <td>
              <ng-container *ngIf="it.cost != null; else noCost">{{ it.cost | currency: 'COP':'symbol-narrow':'1.0-0' }}</ng-container>
              <ng-template #noCost><span class="jc-muted">{{ 'salud.noCostRegistered' | transloco }}</span></ng-template>
            </td>
            <td>
              <ng-container *ngIf="it.provider; else noProvider">{{ it.provider.name }}</ng-container>
              <ng-template #noProvider><span class="jc-muted">{{ 'salud.noProviderRegistered' | transloco }}</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<!-- El mini-form de compra lo declara el wrapper (la lógica de órdenes vive allá). -->
<ng-template #buyFormSlot>
  <ng-container *ngTemplateOutlet="buyFormTpl"></ng-container>
</ng-template>

<!-- El mini-form de agendar lo declara el wrapper (mismo patrón que buyFormSlot). -->
<ng-template #scheduleFormSlot>
  <ng-container *ngTemplateOutlet="scheduleFormTpl"></ng-container>
</ng-template>
